/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';

import { Text, Box, Flex, Button, Input } from '@chakra-ui/react';
import { SubmitHandler, useForm } from 'react-hook-form';

import { useUser } from '~/containers';
import toast from 'react-hot-toast';
import SectionHeader from '~/components/molecules/SectionHeader';
import { InputLabel } from '~/components/atoms';
import { useNavigate } from 'react-router-dom';
import styles from './AuthForm.module.css';

type SignInFormInput = {
  email: string;
  password: string;
};

export type Props = {
  afterComplete: () => void;
  showSignUpForm: () => void;
  showResetPasswordForm: () => void;
};

const SignInForm: React.FC<Props> = ({
  showSignUpForm,
  showResetPasswordForm,
  afterComplete,
}) => {
  const navigate = useNavigate();
  const { login } = useUser();

  const {
    handleSubmit,
    register,
    formState: { isSubmitting, errors },
  } = useForm<SignInFormInput>({
    mode: 'onBlur',
  });

  const onSubmit: SubmitHandler<SignInFormInput> = async (input) => {
    try {
      await login(input.email, input.password);
      afterComplete();
      navigate('/topics');
    } catch {
      toast.error('ログインに失敗しました');
    }
  };

  return (
    <>
      <SectionHeader title="ログイン" subtitle="login" />
      <Box maxW="500px" margin="auto">
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box py="15px">
            <InputLabel text="メールアドレス" />
            <Input
              autoComplete="username"
              className={styles.txt}
              type="email"
              required
              isInvalid={!!errors.email}
              {...register('email', { required: true })}
            />
            <Text color="#b8526b">
              {errors.email?.type !== 'required' && errors.email?.message}
            </Text>
          </Box>
          <Box py="15px">
            <InputLabel text="パスワード" />
            <Input
              autoComplete="current-password"
              className={styles.txt}
              type="password"
              minLength={8}
              required
              isInvalid={!!errors.password}
              {...register('password', { required: true })}
            />
            <Text fontSize="md">
              パスワードをお忘れですか？
              <Button
                variant="link"
                textColor="#0a94cf"
                onClick={showResetPasswordForm}
              >
                パスワードをリセット
              </Button>
            </Text>
          </Box>
          <Flex alignItems="center" direction="column" py="30px">
            <Button
              type="submit"
              isLoading={isSubmitting}
              w="240px"
              h="auto"
              bg="#0a94cf"
              color="white"
              fontWeight="normal"
              fontSize="1.5rem"
              borderRadius="0"
              padding="0.6em 0"
              _hover={{ bg: '#cf1359' }}
            >
              ログイン
            </Button>
            <Text py="20px">
              ユーザーが未登録ですか？
              <Button
                variant="link"
                textColor="#0a94cf"
                onClick={showSignUpForm}
              >
                ユーザーを登録する
              </Button>
            </Text>
          </Flex>
        </form>
      </Box>
    </>
  );
};

export default SignInForm;
